import { Check, Minus } from "lucide-react";
import { ChapterHeading } from "../ChapterHeading";
import { Reveal } from "../motion/Reveal";

const AI_LIST = [
  "Think of the right prompt",
  "Explain the situation",
  "Regenerate tone",
  "Edit generic wording",
  "Judge whether it sounds too soft or too harsh",
  "Repeat the process every time",
];

const SAYIT_LIST = [
  "Find the situation",
  "Pick Warm, Balanced or Firm",
  "Customize the bracketed details",
  "Copy or use it immediately",
  "Consistent editorial standard",
  "Ready whenever you need it",
];

export function AIComparison() {
  return (
    <section id="why-not-ai" className="py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <ChapterHeading
          index="05"
          eyebrow="A fair question"
          title={
            <>
              Couldn't I just <em className="font-normal">ask AI?</em>
            </>
          }
        />
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-smoke sm:text-lg">
            Of course. But then you still need to write the prompt, explain the
            context, regenerate awkward answers, decide whether the response is
            too soft or too harsh, and edit the result. SayIt has already done
            that work.
          </p>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <Reveal delay={0.1} className="h-full">
            <div className="h-full rounded-xl border border-line bg-paper p-8">
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-faint">
                Asking AI from scratch
              </p>
              <ul className="mt-6 space-y-4">
                {AI_LIST.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-smoke">
                    <Minus className="mt-0.5 h-4 w-4 shrink-0 text-faint" />
                    <span className="text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={0.2} className="h-full">
            <div className="h-full rounded-xl border border-ink/20 bg-ink p-8 shadow-[0_30px_60px_-40px_rgba(20,19,17,0.5)]">
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#a8a499]">
                Using SayIt
              </p>
              <ul className="mt-6 space-y-4">
                {SAYIT_LIST.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-paper">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-amber-500" />
                    <span className="text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
